<section class="amortization-plan-details">
  <app-form-header
    [menuDefinition]="menuDefinition"
    [params]="headerParams"
    [showSave]="canManageAmortizationPlans"
    (onSave)="onSubmit()"
    (onCancel)="cancel()"
  ></app-form-header>

  @if (form) {
    <form class="astral-content-width astral-content-width--with-list-surface astral-surface-stack" [formGroup]="form">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['companyName']"></astral-input>
          <astral-input [control]="form.controls['debtorContactName']"></astral-input>
          @if (canEditLeaseAgreement) {
            <astral-select
              [control]="form.controls['leaseAgreementId']"
              [itemsSource]="leaseAgreementSelection"
            ></astral-select>
          } @else {
            @if (!showSeparatePaymentNoticeInfo) {
              <astral-input
                [control]="form.controls['leaseAgreementDisplayName']"
              ></astral-input>
            } @else {
              <div class="astral-layout-item">
                <label class="amortization-plan-details__info-label">
                  {{ 'AMORTIZATION_PLAN.CREATE.LEASE_AGREEMENT' | translate }}
                </label>
                <div class="amortization-plan-details__info-text">
                  {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICES_CREATED_SEPARATELY' | translate }}
                </div>
              </div>
            }
          }
          @if (canEditInterestSettings) {
            <astral-select
              [control]="form.controls['articleId']"
              [itemsSource]="articleSelection"
            ></astral-select>
          } @else {
            <astral-input [control]="form.controls['articleCaption']"></astral-input>
          }
          <astral-input [control]="form.controls['statusText']"></astral-input>
          <astral-input
            type="number"
            inputMode="decimal"
            [step]="0.01"
            [control]="form.controls['interestRate']"
          ></astral-input>
          <app-money-box [control]="form.controls['totalAmount']"></app-money-box>
          @if (showCalculatedInterestAmount) {
            <app-money-box
              [control]="form.controls['calculatedInterestAmount']"
            ></app-money-box>
          }
          <app-invoice-delivery-method
            [control]="form.controls['paymentNoticeDeliveryMethod']"
            [allowedMethods]="paymentNoticeDeliveryMethods"
          ></app-invoice-delivery-method>
          @if (showSeparateInterestInvoiceDeliveryMethod) {
            <app-invoice-delivery-method
              [control]="interestInvoiceDeliveryGroup.controls['deliveryMethod']"
            ></app-invoice-delivery-method>
          }
          @if (showInterestInvoiceDelivery && showInterestInvoiceEmail) {
            <app-email-box
              [control]="interestInvoiceDeliveryGroup.controls['email']"
            ></app-email-box>
          }
          @if (showInterestInvoiceDelivery && showInterestInvoiceEInvoiceAddress) {
            <astral-input
              [control]="interestInvoiceDeliveryGroup.controls['eInvoiceAddress']"
            ></astral-input>
          }
          @if (showDeliveryAddress) {
            <div class="astral-grid-full">
              <app-postal-address
                [group]="interestInvoiceDeliveryAddressGroup"
                [model]="interestInvoiceDeliveryAddressModel"
                [mandatory]="showInterestInvoicePostalAddress"
                [showName]="true"
                [nameLabel]="'ADDRESS_FORM.RECIPIENT_LABEL'"
                [title]="''"
              ></app-postal-address>
            </div>
          }
          @if (showInterestInvoiceLink) {
            <div class="astral-layout-item">
              <label class="amortization-plan-details__link-label">
                {{ 'AMORTIZATION_PLAN.INTEREST_INVOICE' | translate }}
              </label>
              <astral-button
                variant="link-button"
                [label]="interestInvoiceLinkText"
                [link]="interestInvoiceUrl"
              ></astral-button>
            </div>
          }
          @if (showESignatureErrandLink) {
            <div class="astral-layout-item">
              <label class="amortization-plan-details__link-label">{{ 'COMMON.DIGITAL_SIGNING' | translate }}</label>
              <astral-button
                variant="link-button"
                [labelKey]="eSignatureErrandLinkTextKey"
                [link]="eSignatureErrandUrl"
              ></astral-button>
            </div>
          }
          <astral-input [control]="form.controls['createdAt']"></astral-input>
          <astral-textarea [span]="'full'" [control]="form.controls['note']" [rows]="3"></astral-textarea>
        </astral-layout-group>
      </section>
      @if (canGeneratePdf || canApprove || canWithdrawApproval || canSendForDigitalSigning || canCancelPlan) {
        <div
          class="astral-form-actions"
          >
          @if (canGeneratePdf) {
            <astral-button
              variant="secondary"
              type="button"
              icon="pdf"
              labelKey="AMORTIZATION_PLAN.COMMAND.PREVIEW_PDF"
              (click)="previewPdf()"
            ></astral-button>
          }
          @if (canApprove) {
            <astral-button
              variant="primary"
              type="button"
              labelKey="AMORTIZATION_PLAN.COMMAND.APPROVE"
              (click)="approve()"
            ></astral-button>
          }
          @if (canWithdrawApproval) {
            <astral-button
              variant="secondary"
              type="button"
              labelKey="AMORTIZATION_PLAN.COMMAND.WITHDRAW_APPROVAL"
              (click)="withdrawApproval()"
            ></astral-button>
          }
          @if (canSendForDigitalSigning) {
            <astral-button
              variant="primary"
              type="button"
              labelKey="COMMON.SEND_FOR_DIGITAL_SIGNING"
              (click)="sendForDigitalSigning()"
            ></astral-button>
          }
          @if (canCancelPlan) {
            <astral-button
              variant="secondary"
              type="button"
              labelKey="AMORTIZATION_PLAN.COMMAND.CANCEL"
              (click)="cancelPlan()"
            ></astral-button>
          }
        </div>
      }
      @if (showInvoices) {
        <section class="astral-section-surface astral-section-surface--list-width astral-form-stack astral-form-stack--relaxed">
          <h4 class="astral-section-heading">{{ 'AMORTIZATION_PLAN.INVOICES' | translate }}</h4>
          <app-list-view
            [columnDefinition]="invoiceColumnDefinition"
            [itemsSource]="dataContext.invoices"
            [preferencesKey]="'invoice.amortization-plan.invoices'"
            (rowClick)="onInvoiceRowClicked($event)"
          ></app-list-view>
        </section>
      }
      @if (showPaymentNotices) {
        <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed">
          <h4 class="astral-section-heading">{{ 'AMORTIZATION_PLAN.PAYMENT_NOTICES' | translate }}</h4>
          <div class="astral-form-stack astral-form-stack--relaxed">
            @for (paymentNotice of dataContext.paymentNotices; track paymentNotice) {
              <article class="payment-notice-card">
                <div class="payment-notice-card__header">
                  <div>
                    <div class="payment-notice-card__title">{{ paymentNotice.ocrNumber }}</div>
                    <div class="payment-notice-card__subtitle">
                      {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.DELIVERY_METHOD' | translate }}:
                      {{ getReminderDeliveryMethodKey(paymentNotice.deliveryMethod) | translate }}
                    </div>
                  </div>
                  <div class="payment-notice-card__header-actions">
                    <span class="payment-notice-card__status" [ngClass]="getPaymentNoticeStatusClass(paymentNotice)">
                      {{ getPaymentNoticeStatusKey(paymentNotice) | translate }}
                    </span>
                    @if (canRequestPaymentNoticeDelivery(paymentNotice)) {
                      <astral-button
                        variant="primary"
                        size="small"
                        type="button"
                        [labelKey]="getPaymentNoticeActionKey(paymentNotice)"
                        (click)="requestPaymentNoticeDelivery(paymentNotice)"
                      ></astral-button>
                    }
                    <astral-button
                      variant="secondary"
                      size="small"
                      type="button"
                      icon="pdf"
                      labelKey="AMORTIZATION_PLAN.PAYMENT_NOTICE.PRINT_PDF_ACTION"
                      (click)="previewPaymentNoticePdf(paymentNotice)"
                    ></astral-button>
                    @if (canRegisterPaymentNoticePayment(paymentNotice)) {
                      <astral-button
                        variant="primary"
                        size="small"
                        type="button"
                        labelKey="AMORTIZATION_PLAN.PAYMENT_NOTICE.REGISTER_PAYMENT_ACTION"
                        (click)="registerPaymentNoticePayment(paymentNotice)"
                      ></astral-button>
                    }
                  </div>
                </div>
                <div class="payment-notice-card__summary">
                  <div class="payment-notice-card__field">
                    <span class="payment-notice-card__label">{{ 'INVOICE.OCRNUMBER' | translate }}</span>
                    <span>{{ paymentNotice.ocrNumber }}</span>
                  </div>
                  <div class="payment-notice-card__field">
                    <span class="payment-notice-card__label">{{ 'INVOICE.DUE_DATE' | translate }}</span>
                    <span>{{ formatLocalDate(paymentNotice.dueDate) }}</span>
                  </div>
                  <div class="payment-notice-card__field">
                    <span class="payment-notice-card__label">{{ 'COMMON.AMOUNT' | translate }}</span>
                    <span>{{ paymentNotice.amount }}</span>
                  </div>
                  <div class="payment-notice-card__field">
                    <span class="payment-notice-card__label">{{ 'INVOICE.REMAINING_AMOUNT' | translate }}</span>
                    <span>{{ paymentNotice.remainingAmount }}</span>
                  </div>
                  <div class="payment-notice-card__field">
                    <span class="payment-notice-card__label">{{ 'COMMON.CREATED_DATE' | translate }}</span>
                    <span>{{ formatDateTime(paymentNotice.createdDate) }}</span>
                  </div>
                  @if (paymentNotice.deliveryAddress) {
                    <div class="payment-notice-card__field">
                      <span class="payment-notice-card__label">
                        {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.DELIVERY_ADDRESS' | translate }}
                      </span>
                      <span>{{ paymentNotice.deliveryAddress }}</span>
                    </div>
                  }
                  @if (paymentNotice.sentDate) {
                    <div class="payment-notice-card__field">
                      <span class="payment-notice-card__label">{{ 'DIRECT_DEBIT.EXPORT_DATE' | translate }}</span>
                      <span>{{ formatDateTime(paymentNotice.sentDate) }}</span>
                    </div>
                  }
                </div>
                @if (paymentNotice.latestDelivery) {
                  <section class="payment-notice-card__latest">
                    <h5>{{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.LATEST_DELIVERY' | translate }}</h5>
                    <div class="payment-notice-card__summary">
                      <div class="payment-notice-card__field">
                        <span class="payment-notice-card__label">{{ 'COMMON.STATUS' | translate }}</span>
                        <span>{{ getDeliveryStatusKey(paymentNotice.latestDelivery) | translate }}</span>
                      </div>
                      <div class="payment-notice-card__field">
                        <span class="payment-notice-card__label">
                          {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.ATTEMPT_COUNT' | translate }}
                        </span>
                        <span>{{ paymentNotice.latestDelivery.attemptCount }}</span>
                      </div>
                      @if (paymentNotice.latestDelivery.lastAttemptedAt) {
                        <div class="payment-notice-card__field">
                          <span class="payment-notice-card__label">
                            {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.LAST_ATTEMPTED_AT' | translate }}
                          </span>
                          <span>{{ formatDateTime(paymentNotice.latestDelivery.lastAttemptedAt) }}</span>
                        </div>
                      }
                      @if (paymentNotice.latestDelivery.sentDate) {
                        <div class="payment-notice-card__field">
                          <span class="payment-notice-card__label">
                            {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.SENT_AT' | translate }}
                          </span>
                          <span>{{ formatDateTime(paymentNotice.latestDelivery.sentDate) }}</span>
                        </div>
                      }
                      @if (paymentNotice.latestDelivery.provider) {
                        <div class="payment-notice-card__field">
                          <span class="payment-notice-card__label">
                            {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.PROVIDER' | translate }}
                          </span>
                          <span>{{ paymentNotice.latestDelivery.provider }}</span>
                        </div>
                      }
                      @if (paymentNotice.latestDelivery.providerReference) {
                        <div class="payment-notice-card__field">
                          <span class="payment-notice-card__label">
                            {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.PROVIDER_REFERENCE' | translate }}
                          </span>
                          <span>{{ paymentNotice.latestDelivery.providerReference }}</span>
                        </div>
                      }
                      @if (paymentNotice.latestDelivery.emailDeliveryStatusText) {
                        <div class="payment-notice-card__field">
                          <span class="payment-notice-card__label">
                            {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.EMAIL_DELIVERY_STATUS' | translate }}
                          </span>
                          <span>{{ paymentNotice.latestDelivery.emailDeliveryStatusText }}</span>
                        </div>
                      }
                      @if (paymentNotice.latestDelivery.errorMessage) {
                        <div
                          class="payment-notice-card__field payment-notice-card__field--full"
                          >
                          <span class="payment-notice-card__label">
                            {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.ERROR_MESSAGE' | translate }}
                          </span>
                          <span>{{ getDeliveryErrorKey(paymentNotice.latestDelivery) | translate }}</span>
                        </div>
                      }
                    </div>
                  </section>
                } @else {
                  <section class="payment-notice-card__latest">
                    <h5>{{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.LATEST_DELIVERY' | translate }}</h5>
                    <p class="payment-notice-card__empty">
                      {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.DELIVERY_STATUS_NOT_REQUESTED' | translate }}
                    </p>
                  </section>
                }
                @if (paymentNotice.deliveries?.length) {
                  <section class="payment-notice-card__history">
                    <h5>{{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.DELIVERY_HISTORY' | translate }}</h5>
                    @for (delivery of paymentNotice.deliveries; track delivery) {
                      <div class="payment-notice-card__history-item">
                        <div class="payment-notice-card__history-header">
                          <span class="payment-notice-card__status" [ngClass]="getDeliveryStatusClass(delivery)">
                            {{ getDeliveryStatusKey(delivery) | translate }}
                          </span>
                          <span>{{ formatDateTime(delivery.createdDate) }}</span>
                        </div>
                        <div class="payment-notice-card__history-body">
                          <span>{{ getReminderDeliveryMethodKey(delivery.method) | translate }}</span>
                          @if (delivery.providerReference) {
                            <span>
                              {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.PROVIDER_REFERENCE' | translate }}:
                              {{ delivery.providerReference }}
                            </span>
                          }
                          @if (delivery.emailDeliveryStatusText) {
                            <span>
                              {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.EMAIL_DELIVERY_STATUS' | translate }}:
                              {{ delivery.emailDeliveryStatusText }}
                            </span>
                          }
                          @if (delivery.errorMessage) {
                            <span>
                              {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.ERROR_MESSAGE' | translate }}:
                              {{ getDeliveryErrorKey(delivery) | translate }}
                            </span>
                          }
                        </div>
                      </div>
                    }
                  </section>
                }
              </article>
            }
          </div>
        </section>
      }
      @if (showInstallments) {
        <section class="astral-section-surface astral-section-surface--list-width astral-form-stack astral-form-stack--relaxed">
          <h4 class="astral-section-heading">{{ 'AMORTIZATION_PLAN.INSTALLMENTS' | translate }}</h4>
          <app-list-view
            [columnDefinition]="installmentColumnDefinition"
            [itemsSource]="dataContext.installments"
            [preferencesKey]="'invoice.amortization-plan.installments'"
          ></app-list-view>
        </section>
      }
      @if (dataContext?.id) {
        <section class="astral-section-surface astral-section-surface--list-width astral-form-stack astral-form-stack--relaxed">
          <div class="astral-section-heading-actions">
            <h4 class="astral-section-heading">{{ 'DOCUMENT.DOCUMENTS' | translate }}</h4>
            @if (canManageAmortizationPlans) {
              <astral-button
                variant="primary"
                size="small"
                type="button"
                icon="plus"
                labelKey="LEASE_AGREEMENT.COMMAND.LINK_DOCUMENT"
                (click)="linkDocument()"
              ></astral-button>
            }
          </div>
          <app-amortization-plan-document-manager
            [amortizationPlanId]="dataContext.id"
            [canManage]="canManageAmortizationPlans"
          ></app-amortization-plan-document-manager>
        </section>
      }
      @if (dataContext?.id) {
        <astral-accordion
          [header]="'LOG.HEADER'"
          [startExpanded]="true"
          (stateChanged)="allowSectionInit('logs')"
          [allowWidthExpansion]="true">
          @if (isSectionAllowed('logs')) {
            <app-list-view
              [columnDefinition]="logColumnDefinition"
              [itemsSource]="logs"
              [preferencesKey]="'invoice.amortization-plan.logs'"
            ></app-list-view>
          }
        </astral-accordion>
      }
    </form>
  }
</section>
